import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { Toaster as ProfylrToaster, dismissAllToasts } from '@profylr/ui'

/**
 * The design-system Toaster, scoped to the view that raised each toast.
 * Without the route-change dismissal an interceptor error from one page
 * follows the user across every subsequent navigation and reads as those
 * pages having failed.
 */
export function Toaster() {
  const { pathname } = useLocation()

  useEffect(() => {
    dismissAllToasts()
  }, [pathname])

  return <ProfylrToaster />
}
